define.alias("ember-composable-helpers/helpers/flatten", "media/helpers/flatten");